// extracted by mini-css-extract-plugin
module.exports = {"developers-page":"Developers_developers-page__2vWpW","cards-container":"Developers_cards-container__2NK6S"};